import React from 'react';

import { useLocation } from 'react-router-dom';

import { SidebarAccountsQuery } from './graphql/query.sidebarAccounts.generated';

import { urlBuilder } from '../../../Shared/urlBuilder';
import { useProcessNavTransition } from '../../hooks/useProcessNavTransition';
import { NavLink, navLinkStyles } from '../nav-link/NavLink';

type Envelope = SidebarAccountsQuery['envelopes'][number];
type Props = { envelope: Envelope };

export const EnvelopeItem: React.FC<Props> = ({ envelope }) => {
  const onClick = useProcessNavTransition();
  const location = useLocation();

  const accountUrls = envelope.accounts.map(account => {
    return account.__typename === 'CheckingAccount'
      ? account.remote && urlBuilder.getAppCheckingSummary({ accountId: account.remote.checkingAccountId })
      : urlBuilder.appAccount({ accountId: account.id });
  });

  const isAccountActive = accountUrls.includes(location.pathname);

  if (!envelope.purpose) return null;

  return (
    <NavLink
      key={envelope.id}
      className={navLinkStyles({ spacing: 'expanded' })}
      to={urlBuilder.appPurpose({ purposeId: envelope.purpose.id })}
      onClick={onClick}
      data-active={isAccountActive}
    >
      <NavLink.Icon asChild={true}>
        <img src={envelope.purpose.image.dark} alt="" />
      </NavLink.Icon>
      <NavLink.Text>{envelope.purpose.name}</NavLink.Text>
    </NavLink>
  );
};
